export const getSelectorName = (wlName, cuName) => `${wlName || 'Select WL/CU'}${cuName ? `/${cuName}`: ''}`
